import { IncomingMessage } from "http";

/**
 * Get user country code from request headers
 */
export const getUserCountryFromRequest = (req: IncomingMessage): string | undefined => {
    return (req.headers["cf-ipcountry"] as string) || "";
};
